import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../api/api";

export default function UnsubscribeSubscription() {
    const { token } = useParams();

    const [status, setStatus] = useState("loading");
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (!token) {
            setStatus("error");
            setMessage("Invalid unsubscribe link.");
            return;
        }

        setStatus("ready");
    }, [token]);


    const handleUnsubscribe = () => {
        setStatus("loading");

        api.post("/subscribe/unsubscribe", {
            token: token,
        })
            .then((res) => {
                setStatus("unsubscribed");
                setMessage(res.data.message);
            })
            .catch((err) => {
                setStatus("error");
                setMessage(
                    err.response?.data?.message || "Something went wrong."
                );
            });
    };


    return (
        <div className="
            min-h-screen
            flex
            items-center
            justify-center
            bg-[#FCFAF5]
            dark:bg-gray-950
            px-4
        ">

            <div className="
                bg-white
                dark:bg-gray-900
                rounded-[35px]
                shadow-2xl
                border
                border-[#DDD2BA]
                dark:border-gray-800
                p-8
                max-w-md
                w-full
                text-center
            ">


                {/* Loading */}
                {status === "loading" && (
                    <p className="
                        text-[#0F766E]
                        font-medium
                    ">
                        Processing...
                    </p>
                )}




                {/* Ready */}
                {status === "ready" && (
                    <div>

                        <div className="
                            w-20
                            h-20
                            mx-auto
                            rounded-full
                            bg-[#0F766E]/10
                            flex
                            items-center
                            justify-center
                            text-5xl
                            mb-5
                        ">
                            📧
                        </div>


                        <h2 className="
                            text-gray-900
                            dark:text-white
                            font-bold
                            text-xl
                        ">
                            Confirm Unsubscribe
                        </h2>


                        <p className="
                            text-gray-500
                            dark:text-gray-400
                            mt-3
                            leading-relaxed
                        ">
                            Are you sure you want to unsubscribe from our newsletter?
                        </p>



                        <button
                            onClick={handleUnsubscribe}
                            className="
                                mt-6
                                bg-[#0F766E]
                                hover:bg-[#B89442]
                                text-white
                                px-6
                                py-3
                                rounded-full
                                text-sm
                                font-semibold
                                shadow-md
                                transition-all
                                duration-300
                            "
                        >
                            Yes, Unsubscribe
                        </button>

                    </div>
                )}






                {/* Success */}
                {status === "unsubscribed" && (
                    <div>


                        <div className="
                            w-20
                            h-20
                            mx-auto
                            rounded-full
                            bg-[#B89442]/10
                            flex
                            items-center
                            justify-center
                            text-5xl
                            mb-5
                        ">
                            👋
                        </div>


                        <h2 className="
                            text-[#0F766E]
                            dark:text-[#B89442]
                            font-bold
                            text-xl
                        ">
                            Unsubscribed Successfully
                        </h2>


                        <p className="
                            text-gray-500
                            dark:text-gray-400
                            mt-3
                        ">
                            {message}
                        </p>


                    </div>
                )}






                {/* Error */}
                {status === "error" && (
                    <div>

                        <div className="
                            text-5xl
                            mb-4
                        ">
                            ⚠️
                        </div>


                        <p className="
                            text-[#B89442]
                            font-semibold
                        ">
                            {message}
                        </p>


                    </div>
                )}


            </div>

        </div>
    );
}